import React from 'react'
import {Link} from 'react-router-dom'

// import AboutUs from '../components/AboutUs'
// import Members from '../components/Members'
import Allies from '../components/Allies'
import Markdown from 'react-markdown'
import Clients from '../components/Clients'
import Recognition from '../components/Recognition'
import Introduction from '../components/Introduction'
import about from '../lib/about'

export const Dark = () => <div>
  <Markdown source={about.address} />
  <Introduction />
  <section>
    <h3 style={{marginBottom: 0}}>Get in touch</h3>
    <p style={{marginTop: 0}}>Say <a href="mailto:hello@very.film" >hello@very.film</a></p>
  </section>
  <Allies />
  <Clients />
  <section>
    <p>
      <h3>
        <a rel="noreferrer" style={{marginRight: '0.8em'}} href="https://vimeo.com/veryfilm">Vimeo</a>
        <a rel="noreferrer" href="http://instagram.com/very.film">Instagram</a>
      </h3>
    </p>
  </section>
  <section>
    <p className='small'>
      <Link to='/legal'>Legal</Link>
    </p>
  </section>
</div>

export const Light = () => <div>
  <Recognition />
  {/* <Clients /> */}
</div>



// WEBPACK FOOTER //
// ./src/views/About.js